import { FolderStructureParamsDictionary } from "../../../../api/data-types";

export const mandatoryKeys: string[] = [
  "Identifier",
  "AgreementPacket",
  "Title",
  "Author",
  "AuthorID",
  "AuthorEmail",
];

export const EMPTY_DICTIONARY = new FolderStructureParamsDictionary([]);
